import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var innerStyle = 'fx_2d2fb1e5_1hp4k8x1';
var rootStyle = 'fx_2d2fb1e5_1hp4k8x0';
var slotRootStyle = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1hp4k8x2',variantClassNames:{side:{left:'fx_2d2fb1e5_1hp4k8x3',right:'fx_2d2fb1e5_1hp4k8x4'}},defaultVariants:{},compoundVariants:[]});
var titleStyle = 'fx_2d2fb1e5_1hp4k8x5';

export { innerStyle, rootStyle, slotRootStyle, titleStyle };
//# sourceMappingURL=toast-content.vanilla.mjs.map
